<script>
import form from '@/utils/form';

import BaseField from '@/components/BaseField.vue';
import BasePopup from '@/components/BasePopup.vue';
import DecorCategorySelector from '@/components/exchange/material/MaterialCategorySelector.vue';

export default {
  name: 'ExchangeBidForm',
  components: { BasePopup, BaseField, DecorCategorySelector }, // eslint-disable-line
  controller: null,
  data() {
    return {
      isOpened: false,
      /* eslint-disable */
      form: {
        name: form.createFieldObject('string', 'Ниименование', ''),
        vendorCode: form.createFieldObject('string', 'Артикул', ''),
        color: form.createFieldObject('string', 'Цвет', ''),
        volume: form.createFieldObject('float', 'Объем', ''),
        volumeUnit: form.createFieldObject('select', 'Ед изм объема', null, {}, { sqmeter: 'м. кв.', kg: 'килограмм', liter: 'литр', piece: 'шт.' }),
        productName: form.createFieldObject('string', 'Одна позиция', ''),
        productPrice: form.createFieldObject('int', 'Цена позиции', ''),
        productQty: form.createFieldObject('float', 'Количество позиций', ''),
        deliveryPrice: form.createFieldObject('int', 'Цена доставки', ''),
        assemblyPrice: form.createFieldObject('int', 'Цена монтажа', ''),
      },
      /* eslint-enable */
    };
  },
  methods: {
    open(item) {
      this.isOpened = true;

      if (item) {
        form.setValues(this.form, item);
      }

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close(save = false) {
      let result = null;

      if (save) {
        result = form.getValues(this.form);
      }

      form.clear(this.form);
      this.isOpened = false;
      this.$options.controller.resolve(result);
    },
  },
};
</script>

<template lang="pug">
  BasePopup(v-if="isOpened" @close="close")
    .exchange-bid-form
      .fields
        BaseField._name(
          v-for="(field, name) in form"
          v-model="field.value"
          v-bind="field"
          :key="name"
          labelOuter
        )
      Btn(lg @click="close(true)") Сохранить
</template>

<style scoped lang="scss">
.fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 40px;
}
</style>
